'use client';

import { APIProvider } from '@vis.gl/react-google-maps';
import { useMapsConfig } from '@/hooks/useMapsConfig';
import { GOOGLE_MAPS_LIBRARIES } from '@/lib/google-maps-constants';

/**
 * Google Maps JavaScript API — Dynamic Library Import (@vis.gl/react-google-maps).
 * Eski script+callback yüklemesinin yerine geçer; tüm harita bileşenleri bunun altında olmalı.
 */
export default function GoogleMapsApiProvider({ children }: { children: React.ReactNode }) {
  const { api_key, isLoading } = useMapsConfig();

  if (isLoading || !api_key) {
    return <>{children}</>;
  }

  return (
    <APIProvider apiKey={api_key} libraries={[...GOOGLE_MAPS_LIBRARIES]}>
      {children}
    </APIProvider>
  );
}
